export const SIGN_IN_CACHE_KEY = 'SIGN_IN_CACHE_KEY';
export const REGISTER_CACHE_KEY = 'REGISTER_CACHE_KEY';
export const VERIFY_CACHE_KEY = 'VERIFY_CACHE_KEY';
